import React from 'react';
import HeaderView from './headerView';

const HeaderContainer = () => {
  return <HeaderView />;
};

export default HeaderContainer;
